import React, { useState, useEffect } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Grid2, Autocomplete, Chip, Typography, IconButton, Checkbox, InputAdornment } from '@mui/material';
import { Iconify } from '../../Minimal/src/components/iconify/iconify';
import config from "../../common/Config";
import { toast } from 'sonner';
import '../../common/commonStyles.css';
import { axiosPostUsersMultipart } from '../../../utils/usersApi';

const AddUsers = ({ onUserAdded, open, onClose }) => {
	const accessToken = localStorage.getItem('accessToken');
	const [roleOptions, setRoleOptions] = useState([]);
	const [selectedRoles, setSelectedRoles] = useState([]);
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const token = localStorage.getItem("token");
	const [formData, setFormData] = useState({
		avatar: '',
		username: '',
		email: '',
		password: '',
		group: '',
		first_name: '',
		last_name: '',
		address: '',
		postcode: '',
		city: '',
		state: '',
		mobile: '',
		confpass: '',
	});
	const [selectedFileName, setSelectedFileName] = useState('');

	const validateForm = () => {
		const newErrors = {};

		if (!formData.first_name) {
			newErrors.first_name = "Mention Name.";
		} else if (formData.first_name.length < 2) {
			newErrors.first_name = "name must consist of at least 2 characters.";
		} else if (formData.first_name.length > 255) {
			newErrors.first_name = "name must not exceed 255 characters.";
		}

		if (!formData.last_name) {
			newErrors.last_name = "Mention Name.";
		} else if (formData.last_name.length < 2) {
			newErrors.last_name = "name must consist of at least 2 characters.";
		} else if (formData.last_name.length > 255) {
			newErrors.last_name = "name must not exceed 255 characters.";
		}

		// Email validation
		if (!formData.email) {
			newErrors.email = "Mention Email Id.";
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.email = "Please enter a valid email.";
		}

		// Phone validation
		if (!formData.mobile) {
			newErrors.mobile = "Phone is Required.";
		} else if (!/^\d{10,12}$/.test(formData.mobile)) {
			newErrors.mobile = "Phone number must be between 10 and 12 digits.";
		}

		if (!selectedRoles || selectedRoles.length === 0) {
			newErrors.group = "Select at least one role.";
		}

		if (!formData.username) {
			newErrors.username = "Mention Name.";
		} else if (formData.username.length < 2) {
			newErrors.username = "name must consist of at least 2 characters.";
		} else if (formData.username.length > 255) {
			newErrors.username = "name must not exceed 255 characters.";
		}

		if (!formData.password) {
			newErrors.password = "Mention Password.";
		} else if (formData.password.length < 2) {
			newErrors.password = "Password must consist of at least 2 characters.";
		} else if (formData.password.length > 255) {
			newErrors.password = "Password must not exceed 255 characters.";
		}

		if (!formData.confpass) {
			newErrors.confpass = "Please confirm your password.";
		} else if (formData.confpass !== formData.password) {
			newErrors.confpass = "Passwords do not match.";
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });

		let fieldErrors = {};
		switch (name) {
			case 'first_name':
				if (!value) {
					fieldErrors.first_name = "Mention Name.";
				} else if (value.length < 2) {
					fieldErrors.first_name = "name must consist of at least 2 characters.";
				} else if (value.length > 255) {
					fieldErrors.first_name = "name must not exceed 255 characters.";
				}
				if (!fieldErrors.first_name) {
					fieldErrors.first_name = '';
				}
				break;

			case 'last_name':
				if (!value) {
					fieldErrors.last_name = "Mention Name.";
				} else if (value.length < 2) {
					fieldErrors.last_name = "name must consist of at least 2 characters.";
				} else if (value.length > 255) {
					fieldErrors.last_name = "name must not exceed 255 characters.";
				}
				if (!fieldErrors.last_name) {
					fieldErrors.last_name = '';
				}
				break;

			case 'email':
				if (!value) {
					fieldErrors.email = "Mention Email Id.";
				} else if (!/\S+@\S+\.\S+/.test(value)) {
					fieldErrors.email = "Please enter a valid email.";
				}
				if (!fieldErrors.email) {
					fieldErrors.email = '';
				}
				break;

			case 'mobile':
				if (!value) {
					fieldErrors.mobile = "Phone is Required.";
				} else if (!/^\d{10,12}$/.test(value)) {
					fieldErrors.mobile = "Phone number must be between 10 and 12 digits.";
				}
				if (!fieldErrors.mobile) {
					fieldErrors.mobile = '';
				}
				break;

			case 'username':
				if (!value) {
					fieldErrors.username = "Mention Name.";
				} else if (value.length < 2) {
					fieldErrors.username = "name must consist of at least 2 characters.";
				} else if (value.length > 255) {
					fieldErrors.username = "name must not exceed 255 characters.";
				}
				if (!fieldErrors.username) {
					fieldErrors.username = '';
				}
				break;

			case 'password':
				if (!value) {
					fieldErrors.password = "Mention password.";
				} else if (value.length < 6) {
					fieldErrors.password = "password must consist of at least 6 digits.";
				} else if (value.length > 6) {
					fieldErrors.password = "password must not exceed 6 digits.";
				}
				if (!fieldErrors.password) {
					fieldErrors.password = '';
				}
				break;

			case 'confpass':
				if (!value) {
					fieldErrors.confpass = "Please confirm your password.";
				} else if (value.length < 6) {
					fieldErrors.confpass = "confirm password must consist of at least 6 digits.";
				} else if (value.length > 6) {
					fieldErrors.confpass = "confirm password must not exceed 6 digits.";
				} else if (value !== formData.password) {
					fieldErrors.confpass = "Passwords do not match.";
				}
				if (!fieldErrors.confpass) {
					fieldErrors.confpass = '';
				}
				break;

			default:
				break;
		}
		setErrors((prevErrors) => ({
			...prevErrors,
			...fieldErrors
		}));
	};

	const fetchUserRoles = async () => {
		const apiUserRolesUrl = `${config.API_URL}/get_users_role`;
		try {
			const response = await fetch(apiUserRolesUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${token}`,
				}
			});

			const data = await response.json();
			console.log(data);
			const formattedOptions = data.data.map(item => ({
				key: `${item.name}`,
				value: item.id,
			}));
			setRoleOptions(formattedOptions);

		} catch {
		}
	};

	const handleRoleChange = (event, newValue) => {
		setSelectedRoles(newValue || []);
		setErrors(prev => ({ ...prev, group: '' }));
	};

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		fetchUserRoles();
	}, []);

	useEffect(() => {
		if (!open) {
			setFormData({
				avatar: '',
				username: '',
				email: '',
				password: '',
				group: '',
				first_name: '',
				last_name: '',
				address: '',
				postcode: '',
				city: '',
				state: '',
				mobile: '',
				confpass: '',
			});
			setSelectedRoles([]);
			setErrors({});
			setSelectedFileName('');
		}
	}, [open]);

	const submitAddUserForm = async (event) => {
		event.preventDefault();

		if (isSubmitting) {
			return;
		}

		if (!validateForm()) return;

		setIsSubmitting(true);

		const submitFormData = new FormData();
		submitFormData.append('first_name', formData.first_name);
		submitFormData.append('last_name', formData.last_name);
		submitFormData.append('email', formData.email);
		submitFormData.append('mobile', formData.mobile);
		submitFormData.append('username', formData.username);
		submitFormData.append('password', formData.password);
		submitFormData.append('address', formData.address || '');
		submitFormData.append('city', formData.city || '');
		submitFormData.append('state', formData.state || '');
		submitFormData.append('postcode', formData.postcode || '');

		selectedRoles.forEach(role => {
			submitFormData.append('group[]', role.value);
		});

		const avatarFile = document.getElementById('avatar')?.files[0];
		if (avatarFile) {
			submitFormData.append('avatar', avatarFile);
		}

		try {
			const result = await axiosPostUsersMultipart(`${config.API_URL}/add_users`, token, submitFormData);
			const msg = result.message;

			if (result.success == true) {
				toast.success("User added successfully.");
				setFormData({
					avatar: '',
					username: '',
					email: '',
					password: '',
					group: '',
					first_name: '',
					last_name: '',
					address: '',
					postcode: '',
					city: '',
					state: '',
					mobile: '',
					confpass: '',
				});
				setSelectedRoles([]);
				setSelectedFileName('');
				onUserAdded();
				onClose();
				window.location.href = config.BASE_URL + '/users/';
			} else {
				toast.error(msg);
			}
		} catch (error) {
			if (error?.message === 'ENCRYPT_KEY_MISSING') {
				toast.error('Encryption key missing.');
			} else {
				toast.error("An error occurred while adding user.");
			}
		} finally {
			setIsSubmitting(false); // Reset loading state
		}
	};

	const handleClose = () => {
		onClose();
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth="md"
			fullWidth
		>
			<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pt: 3, pb: 2 }}>
				<Typography variant="h6" sx={{ fontWeight: 600 }}>
					Add User
				</Typography>
				<IconButton onClick={handleClose} sx={{ p: 0.5 }}>
					<Iconify icon="eva:close-fill" width={20} />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ px: 3, py: 0 }}>
				<Box component="form" id="adduserform" sx={{ py: 1 }}>
					<Grid2 container spacing={3}>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="First Name"
								name="first_name"
								value={formData.first_name}
								onChange={handleChange}
								error={!!errors.first_name}
								helperText={errors.first_name}
								required
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Last Name"
								name="last_name"
								value={formData.last_name}
								onChange={handleChange}
								error={!!errors.last_name}
								helperText={errors.last_name}
								required
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Phone"
								name="mobile"
								type="tel"
								value={formData.mobile}
								onChange={handleChange}
								error={!!errors.mobile}
								helperText={errors.mobile}
								required
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Email"
								name="email"
								type="email"
								value={formData.email}
								onChange={handleChange}
								error={!!errors.email}
								helperText={errors.email}
								required
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Address"
								name="address"
								value={formData.address}
								onChange={handleChange}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="City"
								name="city"
								value={formData.city}
								onChange={handleChange}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Country"
								name="state"
								value={formData.state}
								onChange={handleChange}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Postcode"
								name="postcode"
								value={formData.postcode}
								onChange={handleChange}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Username"
								name="username"
								value={formData.username}
								onChange={handleChange}
								error={!!errors.username}
								helperText={errors.username}
								required
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Password"
								name="password"
								// pattern="[A-Za-z0-9]+"
								value={formData.password}
								onChange={handleChange}
								error={!!errors.password}
								helperText={errors.password}
								required
								type={showPassword ? 'text' : 'password'}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton onClick={() => setShowPassword(!showPassword)}>
												{showPassword ? <Iconify icon="eva:eye-fill" width={20} /> :
													<Iconify icon="eva:eye-off-fill" width={20} />}
											</IconButton>
										</InputAdornment>
									),
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<TextField
								className="form-input-border"
								fullWidth
								size="small"
								label="Confirm Password"
								name="confpass"
								// pattern="[A-Za-z0-9]+"
								value={formData.confpass}
								onChange={handleChange}
								error={!!errors.confpass}
								helperText={errors.confpass}
								required	
								type={showConfirmPassword ? 'text' : 'password'}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                              {showConfirmPassword ? <Iconify icon="eva:eye-fill" width={20} /> :
												<Iconify icon="eva:eye-off-fill" width={20} />}
											</IconButton>
										</InputAdornment>
									)}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<Autocomplete
								className="form-input-border"
								multiple
								options={roleOptions}
								getOptionLabel={(option) => option.key}
								value={selectedRoles}
								onChange={handleRoleChange}
								disableCloseOnSelect
								renderOption={(props, option, { selected }) => (
									<li {...props}>
										<Checkbox
											sx={{
												color: '#F8991D',
												'&.Mui-checked': {
													color: '#F8991D',
												},
												mr: 1,
											}}
											checked={selected}

										/>
										{option.key}
									</li>
								)}
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
										label="Role"
										error={!!errors.group}
										helperText={errors.group}
										required
									/>
								)}
								renderTags={(value, getTagProps) =>
									value.map((option, index) => (
										<Chip
											{...getTagProps({ index })}
											key={option.value}
											label={option.key}
											size="small"
										/>
									))
								}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 4 }}>
							<Box>
								<Button
									variant="outlined"
									component="label"
									fullWidth
									startIcon={<Iconify icon="eva:upload-fill" width={18} />}
									sx={{
										textTransform: 'none',
										justifyContent: 'flex-start',
										borderRadius: '8px',
										fontWeight: 500,
										borderColor: 'rgba(145, 158, 171, 0.32)',
										color: '#637381',
										backgroundColor: '#fff',
										'&:hover': {
											borderColor: 'rgba(145, 158, 171, 0.48)',
											backgroundColor: 'rgba(45, 48, 51, 0.04)',
										},
									}}
								>
									{selectedFileName || 'Upload Passport Size Image'}
									<input
										className="form-input-border"
										type="file"
										accept="image/png, image/jpg, image/jpeg"
										name="avatar"
										id="avatar"
										hidden
										onChange={(e) => {
											const file = e.target.files[0];
											if (file) {
												setSelectedFileName(file.name);
											} else {
												setSelectedFileName('');
											}
										}}
									/>
								</Button>
								{selectedFileName && (
									<Typography
										variant="caption"
										sx={{
											display: 'block',
											mt: 0.5,
											color: '#637381',
											fontSize: '0.75rem',
										}}
									>
										Selected: {selectedFileName}
									</Typography>
								)}
							</Box>
						</Grid2>
					</Grid2>
				</Box>
			</DialogContent>
			<DialogActions sx={{ px: 3, py: 3 }}>
				<Button onClick={handleClose}
					variant="outlined"
					className="button-variant-outlined"
					sx={{ textTransform: 'none' }}>
					Cancel
				</Button>
				<Button
					variant="contained"
					onClick={submitAddUserForm}
					disabled={isSubmitting}
					className="button-variant-contained"
				>
					{isSubmitting ? 'Adding User...' : 'Add User'}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
export default AddUsers;
